import { createFileRoute } from "@tanstack/react-router";
import PartnersPage from "../../../pages/Admin/PartnersPage/PartnersPage";
import { partnersQueryOptions } from "../../../api/usePartners";
import { useSuspenseQuery } from "@tanstack/react-query";

export const Route = createFileRoute("/(app)/admin/partners")({
  component: RouteComponent,
  loader: ({ context }) => {
    return context.queryClient.ensureQueryData(partnersQueryOptions);
  },
});

function RouteComponent() {
  const { data } = useSuspenseQuery(partnersQueryOptions);
  return <PartnersPage partners={data} />;
}
